// @ts-nocheck
/**
 * Rubina Irfan — Cart Drawer
 * Slide-out cart with Section Rendering API refresh, qty/remove, order note.
 */

(function () {
  "use strict";

  var drawer = null;
  var itemsEl = null;
  var footerEl = null;
  var closeBtn = null;
  var subtotalEl = null;
  var countDrawer = null;
  var progressFill = null;
  var lastTrigger = null;

  var FREE_SHIPPING_THRESHOLD = 0; // read from data attribute set by Liquid
  var NOTE_DEBOUNCE_TIMER = null;

  /* ─── Init ─── */
  document.addEventListener("DOMContentLoaded", function () {
    drawer = document.getElementById("ri-cart-drawer");
    if (!drawer) return;

    itemsEl = document.getElementById("ri-cart-items");
    footerEl = document.getElementById("ri-cart-footer");
    closeBtn = drawer.querySelector(".ri-cart-drawer__close");
    subtotalEl = document.getElementById("ri-cart-subtotal");
    countDrawer = document.getElementById("ri-cart-count-drawer");
    progressFill = document.getElementById("ri-cart-progress-fill");

    // Read actual PKR threshold (in smallest currency unit) from data-threshold
    if (progressFill) {
      FREE_SHIPPING_THRESHOLD = parseInt(
        progressFill.getAttribute("data-threshold") || "0",
        10,
      );
    }

    // Close button
    if (closeBtn) closeBtn.addEventListener("click", close);

    // Backdrop click
    var backdrop = drawer.querySelector(".ri-cart-drawer__backdrop");
    if (backdrop) backdrop.addEventListener("click", close);

    // Escape key + focus trap
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") {
        close();
        return;
      }
      trapFocus(e);
    });

    // Open triggers: data-open-cart attribute or .ri-cart-icon
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-open-cart]");
      if (trigger) {
        e.preventDefault();
        lastTrigger = trigger;
        open();
        refresh();
      }
    });

    // ri:cart:updated — open + refresh
    document.addEventListener("ri:cart:updated", function () {
      open();
      refresh();
    });

    // Order note — delegated, debounced
    drawer.addEventListener("input", function (e) {
      if (!e.target.classList.contains("ri-cart-drawer__note")) return;
      clearTimeout(NOTE_DEBOUNCE_TIMER);
      var note = e.target.value;
      NOTE_DEBOUNCE_TIMER = setTimeout(function () {
        postJSON("/cart/update.js", { note: note });
      }, 600);
    });

    // Qty + Remove — delegated on items container
    drawer.addEventListener("click", function (e) {
      // Qty buttons
      var qtyBtn = e.target.closest(".ri-qty-btn");
      if (qtyBtn && itemsEl && itemsEl.contains(qtyBtn)) {
        var key = qtyBtn.dataset.key;
        var action = qtyBtn.dataset.action;
        var numEl = qtyBtn.parentElement.querySelector(
          ".ri-cart-item__qty-num",
        );
        var current = numEl ? parseInt(numEl.textContent, 10) : 1;
        var newQty = action === "plus" ? current + 1 : Math.max(0, current - 1);
        changeItem(key, newQty);
        return;
      }

      // Remove button
      var removeBtn = e.target.closest(".ri-cart-item__remove");
      if (removeBtn && itemsEl && itemsEl.contains(removeBtn)) {
        changeItem(removeBtn.dataset.key, 0);
      }
    });
  });

  /* ─── Open / Close ─── */
  function open() {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  /* ─── Focus trap ───
     The drawer is aria-modal="true" but nothing kept focus inside it, so tabbing
     from the checkout button walked straight into the page behind the overlay
     with no visible focus ring. Keep Tab cycling within the panel while open. */
  function trapFocus(e) {
    if (e.key !== "Tab") return;
    if (!drawer || drawer.getAttribute("aria-hidden") !== "false") return;

    var panel = drawer.querySelector(".ri-cart-drawer__panel");
    if (!panel) return;

    var focusable = Array.prototype.filter.call(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      },
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!panel.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ─── Cart mutation ─── */
  function changeItem(key, quantity) {
    setLoading(true);
    postJSON("/cart/change.js", { id: key, quantity: quantity })
      .then(function () {
        refresh();
      })
      .catch(function () {
        setLoading(false);
      });
  }

  /* ─── Refresh via Section Rendering API ─── */
  function refresh() {
    setLoading(true);

    // Fetch cart JSON for counts + subtotal + progress
    var cartJsonReq = fetch("/cart.js", {
      headers: { Accept: "application/json" },
    }).then(function (r) {
      return r.json();
    });

    // Fetch section HTML for items
    var sectionReq = fetch("/?section_id=ri-cart-drawer", {
      headers: { Accept: "text/html" },
    }).then(function (r) {
      return r.text();
    });

    Promise.all([cartJsonReq, sectionReq])
      .then(function (results) {
        var cart = results[0];
        var html = results[1];

        // Parse section HTML and extract #ri-cart-items
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newItems = doc.getElementById("ri-cart-items");
        if (newItems && itemsEl) {
          itemsEl.innerHTML = newItems.innerHTML;
        }

        // Update count everywhere
        var count = cart.item_count;
        var countText = "(" + count + ")";
        if (countDrawer) countDrawer.textContent = countText;
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = count;
        });

        // Update subtotal
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        // Show/hide footer
        if (footerEl) footerEl.style.display = count > 0 ? "" : "none";

        // Update progress bar
        updateProgress(cart.total_price);

        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }

  /* ─── Progress bar ─── */
  function updateProgress(totalPrice) {
    var threshold = FREE_SHIPPING_THRESHOLD;
    if (!progressFill || threshold <= 0) return;

    var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
    progressFill.style.width = pct + "%";
    progressFill.setAttribute("aria-valuenow", pct);

    var msgEl = drawer.querySelector(".ri-cart-drawer__shipping-msg");
    if (!msgEl) return;

    if (totalPrice >= threshold) {
      msgEl.textContent = "✦ You've unlocked free shipping!";
      msgEl.classList.add("ri-cart-drawer__shipping-msg--done");
    } else {
      var remaining = formatMoney(threshold - totalPrice);
      msgEl.textContent = "Spend " + remaining + " more for free shipping";
      msgEl.classList.remove("ri-cart-drawer__shipping-msg--done");
    }
  }

  /* ─── Helpers ─── */
  function setLoading(on) {
    if (itemsEl) itemsEl.classList.toggle("is-loading", on);
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    }).then(function (r) {
      if (!r.ok) throw new Error("cart_error");
      return r.json();
    });
  }

  /* Plain-text price for textContent. RIMoney handles the thousands separators
     the old local copy omitted, and strips the <span class=money> wrapper this
     shop's money_format carries — writing that wrapper into textContent printed
     the tags on screen. */
  function formatMoney(cents) {
    return window.RIMoney.text(cents);
  }
})();
